import { render } from "./AddBankCards.vue?vue&type=template&id=6e071d75"
import script from "./AddBankCards.vue?vue&type=script&lang=js"
export * from "./AddBankCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__